module.exports = __webpack_public_path__ + "img/102a32e.png";